export default __webpack_public_path__ + "assets/home-three-three-small.6bfe2f50bb6ae491e26575c31d59d57b.png";